var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import { tokens } from '@domain-group/fe-brary';
import { ClassNames } from '@emotion/react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LinkContainer = _ref => {
  var wrapperElement = _ref.wrapperElement,
    tabJustification = _ref.tabJustification,
    tabAlignment = _ref.tabAlignment,
    tabGap = _ref.tabGap,
    underline = _ref.underline,
    children = _ref.children,
    _onClick = _ref.onClick,
    activeClass = _ref.activeClass,
    activeLink = _ref.activeLink;
  var getLinkProps = (index, link) => {
    var props = {
      alignment: tabAlignment,
      justification: tabJustification,
      onClick: () => {
        _onClick(index, link.key);
      },
      key: index
    };
    if (activeClass !== undefined && activeLink !== undefined && index === activeLink) {
      props.className = "".concat(link.props.className, " ").concat(activeClass);
    }
    return props;
  };
  return ___EmotionJSX(ClassNames, null, _ref2 => {
    var css = _ref2.css;
    return /*#__PURE__*/React.cloneElement(wrapperElement, {
      className: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n              display: flex;\n              justify-content: flex-start;\n              gap: ", "px;\n              ", "\n            "])), tabGap === 'big' ? 26 : 8, underline && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                border-bottom: 1px solid ", ";\n              "])), tokens.colors.neutral.trim.default))
    }, React.Children.map(children, (link, index) => link && /*#__PURE__*/React.cloneElement(link, getLinkProps(index, link))));
  });
};
LinkContainer.propTypes = {
  wrapperElement: PropTypes.element,
  tabJustification: PropTypes.oneOf(['left', 'right', 'full', 'auto']).isRequired,
  tabAlignment: PropTypes.oneOf(['left', 'centre']).isRequired,
  tabGap: PropTypes.oneOf(['default', 'big']).isRequired,
  underline: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  activeClass: PropTypes.string,
  activeLink: PropTypes.number,
  children: PropTypes.node
};
LinkContainer.defaultProps = {
  wrapperElement: ___EmotionJSX("div", null),
  activeClass: undefined,
  activeLink: undefined,
  children: undefined
};
export default LinkContainer;